module.exports = __webpack_public_path__ + "img/accounts.450122af.svg";